'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var empty = {};

exports.__exports = empty;
